<template>
  <div>
    <div class=" justify-content-between align-items-center">
      <div class="d-flex mb-3">
        <input type="text" class="form-control"  v-model="searchInput" @keyup.enter="onSearchSubmit" placeholder="Rechercher...">
        <button class="btn btn-primary ms-2" @click="toggleFiltersPanel">
          <i class="fe fe-filter"></i> Filtres
          <span v-if="tags.length" class="badge bg-white text-primary ms-1">{{ tags.length }}</span>
        </button>
<!--        <button class="btn btn-success ms-2" @click="exportCSV">Exporter CSV</button>-->
      </div>

    </div>

    <div v-show="showFiltersPanel" class="expanel expanel-default">
      <div class="expanel-body">
        <div class="text-wrap">
          <div class="btn-group mt-2 mb-2">
            <button class="btn btn-outline-primary dropdown-toggle" @click="toggleDropdown">Ajouter un filtre</button>

            <ul class="dropdown-menu" :class="{ 'd-block': dropdownVisible && currentView === 'main' }">
              <li v-for="filter in filterableFields" :key="filter.key">
                <a class="dropdown-item" href="#" @click.prevent="openSubmenu(filter.key)">

                  {{ filter.label }} <i class="fe fe-chevron-right float-end"></i>
                </a>
              </li>
            </ul>

            <div class="dropdown-menu p-3" v-for="filter in filterableFields" :key="filter.key" :class="{ 'd-block': dropdownVisible && currentView === filter.key }">
              <button class="btn btn-sm btn-light mb-2" @click="backToMain">← Retour</button>
              <form @submit.prevent="applyFilter(filter.key)">
                <!-- SELECT avec <statut> -->
                <div class="mb-2" v-if="filter.type === FILTER_TYPES.STATUT">
<span
    v-for="opt in filter.options"
    :key="opt.value"
    class="badge rounded-pill badge-sm me-1 mb-1 mt-1"
    :class="{
  'bg-primary text-white': String(filtersDraft[filter.key]) === String(opt.value),
  'badge-outline text-primary border border-primary': String(filtersDraft[filter.key]) !== String(opt.value)
}"
    style="cursor: pointer"
    @click="toggleOption(filter.key, opt.value)"
>
  {{ opt.label }}
</span>
                </div>

                <!-- SELECT avec <select> -->
                <div class="mb-2" v-if="filter.type === FILTER_TYPES.SELECT">
                  <label :for="'select-' + filter.key" class="form-label">{{ filter.label }}</label>
                  <select
                      :id="'select-' + filter.key"
                      class="form-control form-select"
                      v-model="filtersDraft[filter.key]"
                  >
                    <option value="">-- Sélectionnez --</option>
                    <option v-for="opt in filter.options" :key="opt.value" :value="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                </div>

                <!-- TEXT -->
                <div class="mb-2" v-else-if="filter.type === FILTER_TYPES.TEXT">
                  <input
                      type="text"
                      class="form-control"
                      v-model="filtersDraft[filter.key]"
                      :placeholder="filter.placeholder"
                  />
                </div>

                <!-- DATE -->
                <div class="mb-2" v-else-if="filter.type === FILTER_TYPES.DATE">
                  <input
                      type="date"
                      class="form-control"
                      v-model="filtersDraft[filter.key]"
                  />
                </div>
                <button  class="btn btn-sm btn-primary w-100" type="submit"><span class="fe fe-search"></span> Appliquer</button>
              </form>
            </div>
          </div>

          <div class="btn-group mt-2 mb-2">
            <div class="tags mb-2 ms-2">
     <span class="tag tag-radius tag-round tag-primary" v-for="(tag, index) in tags" :key="index">
    {{ tag.name }} : {{ tag.value }}
    <a href="javascript:void(0)" class="tag-addon" @click="removeTag(index)">
      <i class="fe fe-x"></i>
    </a>
  </span>
            </div>
          </div>

        </div>
      </div>
    </div>
<!--    <div v-if="isLoading" class="loading-overlay">Chargement ...</div>-->
    <div v-if="isLoading" class="dimmer active">
      <div class="spinner1">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
    <div v-else class="table-responsive  mt-3">
      <table class="table table-bordered text-nowrap border-bottom table-hover">
        <thead class="border-top success02">
        <tr class="fw-bold">
          <th v-for="col in columns" class="bg-transparent border-bottom-0 fw-bold" :key="col.key">{{ col.label }}</th>
          <th class="bg-transparent border-bottom-0 fw-bold" v-if="rowActions.length">Actions</th>
        </tr>
        </thead>
        <tbody id="myTable1">
        <template v-if="items.length > 0">
          <tr v-for="item in items" :key="item.id" class="border-bottom">
            <td v-for="col in columns" :key="col.key" :class="col.class || ''" :style="col.style || ''">
              <slot :name="'cell-' + col.key" :item="item">{{ item[col.key] }}</slot>
            </td>
            <td v-if="rowActions.length" class="text-center">
              <button
                  v-for="action in rowActions"
                  :key="action.name"
                  class="btn btn-sm me-1"
                  @click.prevent="$emit(action.event, item)"
              >
                <i :class="action.icon"></i>
              </button>
            </td>
          </tr>
        </template>
        <tr v-else class="primary02">
          <td class="text-center text-muted" :colspan="columns.length + (rowActions.length ? 1 : 0)">
            Aucune donnée à afficher.
          </td>
        </tr>
        </tbody>
      </table>

    </div>

    <div class="mt-3 d-flex justify-content-between justify-content-end" v-if="items.length">
      <div class="text-muted mt-2">
        Affichage de {{ startEntry }} à {{ endEntry }} sur {{ totalElements }} entrées
      </div>
      <nav aria-label="Page navigation example" class="mt-2 d-flex justify-content-center">
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: page === 0 }">
            <a class="page-link" href="#" @click.prevent="changePage(page - 1)">Precedent</a>
          </li>
          <li
              v-for="i in totalPages"
              :key="i"
              class="page-item"
              :class="{ active: page === i - 1 }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(i - 1)">{{ i }}</a>
          </li>
          <li class="page-item" :class="{ disabled: page === totalPages - 1 }">
            <a class="page-link" href="#" @click.prevent="changePage(page + 1)">Suivant</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>

  import debounce from "lodash/debounce";
  import {FILTER_TYPES} from "../helpers/constants";

  export default {

    props: {
      setLoading: {
        type: Function,
        default: () => {},
      },

      columns: Array,

      filterableFields: Array,

      rowActions: {

        type: Array,

        default: () => []

      },
      apiEndpoint: {
        type: String,
        required: true
      },

      pageSize: {

        type: Number,

        default: 10

      },
      searchField: {
        type: String,
        default: null
      }

    },

    data() {

      return {
        isLoading: false,
        filters: { ...this.defaultFilters },
        filtersDraft: { ...this.defaultFilters },

        tags: [],

        currentView: 'main',

        dropdownVisible: false,

        showFiltersPanel: false,
        searchInput: '',

        internalSearch: '',

        isSearching : false,
        page: 0,
        items: [],
        totalPages: 0,
        totalElements: 0,

      };

    },

    computed: {
      FILTER_TYPES() {
        return FILTER_TYPES
      },

      startEntry() {
        return this.totalElements === 0 ? 0 : this.page * this.pageSize + 1;
      },
      endEntry() {
        const end = (this.page + 1) * this.pageSize;
        return end > this.totalElements ? this.totalElements : end;
      }

    },

    methods: {
      async loadData() {
        this.isLoading = true;
        this.setLoading(true);
        // this.$loading(true);
        const params = {
          page: this.page,
          size: this.pageSize,
          ...this.filters
        };

        const isSearchFieldInFilters = this.searchField && Object.keys(this.filters).includes(this.searchField);

        if (!isSearchFieldInFilters && this.searchField && this.internalSearch) {
          params[this.searchField] = this.internalSearch;
        }

        try {
          // this.$loading(true);
          this.setLoading(true);
          const { data } = await this.$http.get(this.apiEndpoint, { params });
          if (data && data.content && data.content.length > 0) {
            this.items = data.content;
            this.totalPages = data.totalPages;
            this.totalElements = data.totalElements;
            this.page = data.number;
          } else {
            this.items = [];
            this.totalPages = 0;
            this.totalElements = 0;
            this.page = 0;
          }
        } catch (error) {
          // this.$loading(true);
          this.setLoading(true);
          console.error('Erreur chargement données:', error);
          this.items = [];
          this.totalPages = 0;
          this.totalElements = 0;
          this.page = 0;
        } finally {
          this.isLoading = false;
          this.setLoading(false);
          // this.$loading(false);
        }
      },
      toggleOption(fieldKey, value) {

        const current = this.filtersDraft[fieldKey];

        if (String(current) === String(value)) {

          this.$set(this.filtersDraft, fieldKey, null);

        } else {

          this.$set(this.filtersDraft, fieldKey, value);

        }

        this.$forceUpdate();

      },


      changePage(newPage) {
        if (newPage >= 0 && newPage < this.totalPages) {
          this.page = newPage;
          this.loadData();
        }
      },


      onSearchSubmit() {
        this.internalSearch = this.searchInput;
        this.page = 0;
        this.loadData();
      },

      toggleFiltersPanel() {

        this.showFiltersPanel = !this.showFiltersPanel;

      },

      toggleDropdown() {

        this.dropdownVisible = !this.dropdownVisible;

        this.currentView = 'main';

      },

      openSubmenu(view) {
        this.filtersDraft[view] = this.filters[view] || '';
        this.currentView = view;

      },

      backToMain() {

        this.currentView = 'main';

      },

      applyFilter(fieldKey) {
        const value = this.filtersDraft[fieldKey];
        if (value === null || value === undefined || value === '') return;

        this.$set(this.filters, fieldKey, value);
        this.filters[fieldKey] = value;

        const existing = this.tags.findIndex(t => t.name === fieldKey);
        const label = value;

        if (existing !== -1) this.tags.splice(existing, 1, { name: fieldKey, value: label });
        else this.tags.push({ name: fieldKey, value: label });

        this.dropdownVisible = false;
        this.currentView = 'main';
        this.page = 0;
        this.loadData();
      },

      removeTag(index) {
        const removedTag = this.tags[index];
        if (removedTag && removedTag.name) {
          this.$delete(this.filters, removedTag.name);
          this.$delete(this.filtersDraft, removedTag.name);
          this.page = 0;
          this.loadData();
        }

        this.tags.splice(index, 1);
      },

      exportCSV() {

        const csvRows = [];

        const headers = this.columns.map(col => col.label);

        csvRows.push(headers.join(","));

        this.items.forEach(row => {

          const values = this.columns.map(col => '"' + (row[col.key] ?? '') + '"');

          csvRows.push(values.join(","));

        });

        const blob = new Blob([csvRows.join("\n")], { type: 'text/csv' });

        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;

        link.download = 'data.csv';

        link.click();

        URL.revokeObjectURL(url);

      },
      handleOutsideClick(event) {
        const dropdown = this.$el.querySelector('.btn-group');
        if (dropdown && !dropdown.contains(event.target)) {
          this.dropdownVisible = false;
          this.currentView = 'main';
        }
      },

    },
    mounted() {
      document.addEventListener('click', this.handleOutsideClick);
      this.loadData();
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleOutsideClick);
    },

  };
</script>

<style scoped>

.d-block {

  display: block !important;

}
</style>

